import React from "react";
import { Button, Modal, Row, Col, Form, Spinner } from "react-bootstrap";
import InputMaterialUi from "input-material-ui";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import { validateEmail, cpfMask, onlyNumbers, isValidCPF } from "../../Utils/ValidationsMasks";
import SweetAlert from "../../Utils/SweetAlert";
import Api from "../../Utils/Axios";
import pdfAvisoPrivacidade from '../../assets/Pdf/Aviso_de_privacidade_Flex_Consulta_V1.2.pdf'


import "./style.css";
import { useState } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));


const ModalCanalTitularDados = (props) => {

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCPF] = useState("");
  const [telefone, setTelefone] = useState("");
  const [perfilTitular, setPerfilTitular] = useState("");
  const [tipoSolicitacao, setTipoSolicitacao] = useState("");
  const [descricao, setDescricao] = useState("");
  const [check, setCheck] = useState(false)
  const [submited, setSubmited] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();



  useEffect(() => {
    if (props.show === false) {
      ClearInputs();
    }
  }, [props.show]);

  function ClearInputs() {
    setNome('')
    setEmail('')
    setCPF('')
    setPerfilTitular('')
    setTipoSolicitacao('')
    setDescricao('')
    setCheck('')
    setTelefone('')
    setSubmited(false);
  }


  function handleSubmit() {
    setSubmited(true);

    if (nome === "" || email === "" || !validateEmail(email) || cpf === "" || !isValidCPF(cpf) || perfilTitular === "" || tipoSolicitacao === "" || descricao === "" || telefone === "") {
      SweetAlert.small({
        timer: 2000,
        type: "error",
        title: "Preencha os campos corretamente!",
        cb: () => { },
      });
    } else {

      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("email", email);
      formData.append("cpf", cpf);
      formData.append("perfilTitular", perfilTitular);
      formData.append("tipoSolicitacao", tipoSolicitacao);
      formData.append("telefone", telefone);
      formData.append("descricao", descricao);

      setLoading(true);
      Api.post("/site_oficial/formulario_lgpd", formData).then(() => {
        setLoading(false);
        ClearInputs();
        SweetAlert.small({
          timer: 2000,
          type: "success",
          title: "Enviado com sucesso!",
          cb: () => { },
        });
      }).catch((e) => {
        setLoading(false);
        SweetAlert.small({
          timer: 2000,
          type: "error",
          title: e,
          cb: () => { },
        });
      })
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      centered
      size="lg"
    >
      <Modal.Body>
        <Form className="my-5">
          <h2 className="fw700 fGrey px-4">Formulário do canal do titular dos dados</h2>
          <Row >
            {" "}
            <Col className="px-5 col-12 col-lg-6" id="FormCanalSuporte">
              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >

                <TextField
                  id="standard-multiline-static"
                  fullWidth
                  label={
                    <span>
                      Nome completo <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Digite o nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  helperText={
                    <span
                      style={{
                        color: "rgb(242,189,189)",
                        fontSize: "12px",
                        visibility: submited && nome == "" ? "visible" : "hidden",
                      }}
                    >
                      Informe um nome válido!
                    </span>
                  }
                />
              </FormControl>

              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >

                <TextField
                  id="standard-multiline-static"
                  fullWidth
                  label={
                    <span>
                      E-mail <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Digite o e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  helperText={
                    <span
                      style={{
                        color: "rgb(242,189,189)",
                        fontSize: "12px",
                        visibility:
                          submited && !validateEmail(email) ? "visible" : "hidden",
                      }}
                    >
                      Informe um email válido!
                    </span>
                  }
                />
              </FormControl>

              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >


                <TextField
                  id="standard-multiline-static"
                  fullWidth
                  label={
                    <span>
                      CPF <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Digite o cpf"
                  value={cpf}
                  onChange={(e) => setCPF(cpfMask(onlyNumbers(e.target.value)))}

                  helperText={
                    <span
                      style={{
                        color: "rgb(242,189,189)",
                        fontSize: "12px",
                        visibility: submited && (cpf == "" || cpf.length != 11) ? "visible" : "hidden",
                      }}
                    >
                      Informe um cpf válido!
                    </span>
                  }
                />
              </FormControl>

            </Col>
            <Col className="px-5  col-12  col-lg-6" id="FormCanalSuporte">
              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >
                <InputLabel id="demo-simple-select-label">
                  <span>
                    Perfil do titular dos dados <span className="text-danger">*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={perfilTitular}
                  onChange={(e) => setPerfilTitular(e.target.value)}
                >
                  <MenuItem value={""} disabled>Selecione o perfil...</MenuItem>
                  <MenuItem value={"Cliente"}> Cliente</MenuItem>
                  <MenuItem value={"Colaborador"}>Colaborador</MenuItem>
                  <MenuItem value={"Fornecedor"}>Fornecedor</MenuItem>
                  <MenuItem value={"Outros"}>Outros...</MenuItem>
                </Select>
                <FormHelperText
                  style={{
                    visibility: submited && perfilTitular == "" ? "visible" : "hidden",
                    color: "rgb(242,189,189)",
                  }}
                >
                  Informe um perfil válido!
                </FormHelperText>
              </FormControl>
              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >
                <InputLabel id="demo-simple-select-label">
                  <span>
                    Tipo de solicitação <span className="text-danger">*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={tipoSolicitacao}
                  onChange={(e) => setTipoSolicitacao(e.target.value)}
                >
                  <MenuItem value={""} disabled>Selecione o tipo de solicitação...</MenuItem>
                  <MenuItem value="acesso_dados">Acessar dados pessoais</MenuItem>
                  <MenuItem value="anonimizacao">Anonimizar dados</MenuItem>
                  <MenuItem value="bloqueio_tratamento">Bloquear tratamento de dados</MenuItem>
                  <MenuItem value="confirmacao_tratamento">Confirmar tratamento de dados</MenuItem>
                  <MenuItem value="correcao_dados">Corrigir dados pessoais</MenuItem>
                  <MenuItem value="duvidas_politica">Dúvidas sobre privacidade</MenuItem>
                  <MenuItem value="eliminacao_dados">Eliminar dados pessoais</MenuItem>
                  <MenuItem value="informacao_consentimento">Informação sobre consentimento</MenuItem>
                  <MenuItem value="informacao_entidades">Entidades com acesso aos dados</MenuItem>
                  <MenuItem value="criterios_decisoes">Decisões automatizadas</MenuItem>
                  <MenuItem value="portabilidade_dados">Portabilidade de dados</MenuItem>
                  <MenuItem value="reportar_incidente">Reportar incidente</MenuItem>
                  <MenuItem value="revisao_decisoes">Revisar decisões automatizadas</MenuItem>
                  <MenuItem value="revogacao_consentimento">Revogar consentimento</MenuItem>
                </Select>
                <FormHelperText
                  style={{
                    visibility:
                      submited && tipoSolicitacao == "" ? "visible" : "hidden",
                    color: "rgb(242,189,189)",
                  }}
                >
                  Informe um valor válido
                </FormHelperText>
              </FormControl>
              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >

                <TextField
                  id="standard-multiline-static"
                  fullWidth
                  label={
                    <span>
                      Número para contato <span className="text-danger">*</span>
                    </span>
                  }
                  placeholder="Digite o número..."
                  value={telefone}
                  onChange={(e) => setTelefone(onlyNumbers(e.target.value))}

                  helperText={
                    <span
                      style={{
                        color: "rgb(242,189,189)",
                        fontSize: "12px",
                        visibility: submited && (telefone == "") ? "visible" : "hidden",
                      }}
                    >
                      Informe um telefone válido!
                    </span>
                  }
                />
              </FormControl>

            </Col>
            <Col md={12} className="px-5" id="FormCanalSuporte">
              <FormControl
                style={{ width: "100%", marginTop: "5px" }}
                className={classes.formControl}
              >

                <TextField
                  id="standard-multiline-static"
                  label="Descrição *"
                  fullWidth
                  placeholder="Digite a descrição..."
                  multiline
                  rows={3}
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                />
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="px-5" id="FormCanalSuporte">
              <Form.Group className="mt-3" controlId="formBasicCheckbox">
                <Form.Check
                  onChange={() => setCheck(!check)}
                  value={check}
                  style={{ fontSize: "14px" }}
                  type="checkbox"
                  label="A Flex utiliza as informações de contato que você nos fornece através do formulário acima, para entrar em contato com relação aos produtos e serviços. Para obter mais informações sobre como tratamos os seus dados pessoais, confira nossa"
                />
                <a target="_blank" href={pdfAvisoPrivacidade} className="ms-4">
                  Aviso de Privacidade
                </a>
              </Form.Group>
            </Col>
          </Row>
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col>
            <Button
              onClick={() => props.setShow(false)}
              className="mx-3 px-4 buttonWhiteModal"
            >
              Cancelar
            </Button>
            <Button
              disabled={loading || nome === "" || email === "" || cpf === "" || perfilTitular === "" || tipoSolicitacao === "" || descricao === "" || !check}
              onClick={() => handleSubmit()}
              className="buttonOrangeModal px-5"
            >
              Enviar
              {loading && (<Spinner size="sm" animation="grow"></Spinner>)}

            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCanalTitularDados;
